module.exports = __webpack_public_path__ + "img/starbucks.1016c507.png";